import React, { useState } from "react";
import { HelpCircle, Plus } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { SectionLayout } from "@/components/SectionLayout";

export const Faq = ({ data }) => {
  const { L } = useLang();
  const faqs = Array.isArray(data) ? data : [];
  const [open, setOpen] = useState(null);

  return (
    <SectionLayout id="faq" icon={HelpCircle}>
      <div className="space-y-2.5">
        {faqs.map((f) => {
          const isOpen = open === f.id;
          return (
            <div
              key={f.id}
              className="maqam-card overflow-hidden rounded-3xl"
              data-testid={`faq-${f.id}`}
            >
              <button
                onClick={() => setOpen(isOpen ? null : f.id)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left"
              >
                <span className="font-display text-lg font-medium text-[#0A192F]">{L(f.q)}</span>
                <span
                  className={`grid h-8 w-8 shrink-0 place-items-center rounded-full bg-[#0A192F]/6 text-[#0A192F] transition-transform duration-300 ${
                    isOpen ? "rotate-45 bg-[#D4AF37] text-[#0A1128]" : ""
                  }`}
                >
                  <Plus size={16} strokeWidth={2} />
                </span>
              </button>
              <div
                className="grid transition-all duration-300 ease-in-out"
                style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
              >
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 text-sm font-light leading-relaxed text-[#0A1128]/75">{L(f.a)}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </SectionLayout>
  );
};
